class ModFilterPosts {
  constructor(el) {
    this.$this = $(el)
    this.$dropdown = this.$this.find('.select-c8')
    this.$baseURL = this.$this.find('#base-url')
    this.clsFilterResult = '.filter-result'
    this.filterParams = []
    this.currentPage = 1
    this.isLoading = false
    this.postType = this.$this.data('post-type')
    this.filterContainerCls = '.filter-post__load-more-container'
  }

  init() {
    this.controlFilterBar()
    this.initLoadMore()
  }

  controlFilterBar() {
    this.$dropdown.on('change', (e) => {
      e.preventDefault()
      this.currentPage = 1
      this.updateFilterParams(1, false)
    })
  }

  initLoadMore() {
    this.$this.on('click', '.filter-post__load-more-btn', (e) => {
      e.preventDefault()
      if (this.isLoading) {
        return;
      }

      const $btn = $(e.currentTarget)
      const nextPage = $btn.data('page')
      this.loadMorePosts(nextPage)
    })
  }

  loadMorePosts(pageNumber) {
    this.currentPage = pageNumber
    this.updateFilterParams(pageNumber, true)
  }

  updateFilterParams(pageNumber = 1, isLoadMore = false) {
    this.searchParams = new URLSearchParams('')
    const baseUrl = this.$baseURL.val()
    this.filterParams = []

    if (pageNumber > 1) {
      this.filterParams.push({ key: 'page', value: pageNumber })
      this.searchParams.set('page', pageNumber)
    }

    if (baseUrl) {
      this.filterParams.push({ key: 'base_url', value: baseUrl })
    }

    this.filterParams.push({ key: 'post_type', value: this.postType })

    this.filterParams.push({ key: 'post_per_page', value: this.$this.find(this.clsFilterResult).data('post-per-page') })
    this.filterParams.push({ key: 'is_load_more', value: isLoadMore ? 1 : 0 })

    this.$dropdown.each((_i, el) => {
      const $el = $(el)
      const key = $el.attr('name')
      const value = $el.val()
      if (key !== null && (value !== 'all' && value !== '')) {
        this.filterParams.push({ key, value })
        this.searchParams.set(key, value)
      }
    })

    if (!isLoadMore) {
      const newUrl = this.searchParams.toString()
        ? `${window.location.pathname}?${this.searchParams.toString()}`
        : window.location.pathname
      window.history.pushState(null, '', newUrl)
    }

    this.callAjax(isLoadMore)
  }

  callAjax(isLoadMore = false) {
    const action = this.$this.find(this.clsFilterResult).data('action')
    this.isLoading = true

    $.ajax({
      type: 'POST',
      url: window.AJAX_URL, // eslint-disable-line
      dataType: 'text',
      data: { action, filterParams: this.filterParams },
      beforeSend: () => {
        if (isLoadMore) {
          this.$this.find('.filter-post__load-more-btn').addClass('loading').find('.btn-text').addClass('hidden')
          this.$this.find('.filter-post__load-more-btn').find('.loading-text').removeClass('hidden')
        } else {
          $('.filter-loading').fadeIn(500)
        }
      },
      success: (response) => {
        if (isLoadMore) {
          // Parse the response to extract the new posts
          const $response = $(response)
          const $newPosts = $response.find('.filter-post__card')

          // Append new posts to the existing list
          this.$this.find('.filter-post__list').append($newPosts)

          // Replace the load more button
          const $loadMoreContainer = $response.find(this.filterContainerCls)
          if ($loadMoreContainer.length) {
            this.$this.find(this.filterContainerCls).replaceWith($loadMoreContainer)
          } else {
            this.$this.find(this.filterContainerCls).remove()
          }
        } else {
          this.$this.find(this.clsFilterResult).html(response)
        }

        if (typeof window.lazyLoadImage !== 'undefined') {
          window.lazyLoadImage.lazyLoadImage()
        }
      },
      error(jqXHR) {
        console.log(`The following error occurred: ${jqXHR}`)
      },
      complete: () => {
        this.isLoading = false
        if (!isLoadMore) {
          $('.filter-loading').fadeOut(500)
        }
      },
    })
  }
}
$('.filter-post').each((_i, el) => {
  new ModFilterPosts(el).init()
})
